import { defineStore } from 'pinia'
import {services, getHeader, APP_VERSION } from '@/assets/js/config.js'
import { useMessagingStore } from './messagingStore';
import { useConfigStore } from '@/stores/configStore';
import { useAccessControlStore } from '@/stores/accessControlStore';
import { useLookupStore } from '@/stores/lookupStore'

import axios from 'axios'

export const useAuthStore = defineStore('authStore', {
  state:() => ({
    auth_loading: false,
    auth_user: null,
    auth_erorr: null,
    auth_refresh: false,
    viewable_customer_ids: [],
    viewable_customer_nrics: [],
    viewable_customer_messages: [],
  }),
  actions : {
    saveToken(access_token, expires_in){
        var auth_token = {
            access_token: access_token,
            exp: Math.round(new Date().getTime() / 1000) + expires_in
        }
        window.localStorage.setItem('auth_token', JSON.stringify(auth_token))
    },
    saveUser(user){
			 	this.auth_user = user
        window.localStorage.setItem('auth_user', JSON.stringify(user))
			},
    clearAuth(){
        this.auth_user = null
        localStorage.clear()
				useConfigStore().fetchAndSetAppCode()
    },
    async login(email, password){  
        const form_data = {
            email : email,
            password : password,
        }

        try {
            this.auth_erorr = null
            this.auth_loading = true
            let header = {
							'Accept': 'application/json',
							'Application-Code': _gAuth.appCode(),
						}
            const res = await axios.post(services.access_control + 'login', form_data, { headers: header })
						if(!_gHlp.isEmpty(res.data)){
														window.localStorage.setItem('app_version',APP_VERSION);
							this.saveToken(res.data.access_token, res.data.expires_in)
							this.saveUser(res.data.user)
							useMessagingStore().setActiveParticipant(res.data.user)
						}


            this.auth_loading = false
        }
        catch (e) {
            this.auth_loading = false
            this.auth_erorr = e.response.data.message
						// _gNotif.errorFunction(e)
            this.clearAuth()
        }
    },
    async loginToken(email, public_code){  
        const form_data = {
            email : email,
            public_code : public_code,
        }

        try {
					this.auth_erorr = null
					let header = {
						'Accept': 'application/json',
						'Application-Code': _gAuth.appCode(),
					}
					const res = await axios.post(services.access_control + 'login-token', form_data, { headers: header })
					if(!_gHlp.isEmpty(res.data)){
						window.localStorage.setItem('app_version',APP_VERSION);
						this.saveToken(res.data.access_token, res.data.expires_in)
						this.saveUser(res.data.user)
						useMessagingStore().setActiveParticipant(res.data.user)
					}
					return true;
        }
        catch (e) {
					this.auth_erorr = e.response.data.message
					_gNotif.errorFunction(e)
					this.clearAuth()
        }
    },
    async fetchUserInfo(token = null){
        if(token){
            window.localStorage.setItem('auth_token', JSON.stringify({
                access_token: token,
            }));
        }
        if(localStorage.getItem("auth_token") === null){
            return;
        }
                try {
            const res = await axios.get(services.access_control + 'active-user-detail', { headers: getHeader() })
            this.saveUser(res.data.data)
        }catch(e) {
					// _gNotif.errorFunction(e)
        }
    },
    async logout(){
			this.auth_refresh = false;
      this.clearAuth()
		},
		async refresh(){  
			if(this.auth_refresh) return;

			let remaining = _gAuth.getActiveRemain();			
			if (remaining > 0) {
				if(remaining < 10000){
					try {
						this.auth_refresh = true;
						const res = await axios.post(services.access_control + 'refresh', form_data, { headers: getHeader(true) })
						if(!_gHlp.isEmpty(res.data)){
							window.localStorage.setItem('app_version',APP_VERSION);
							this.saveToken(res.data.access_token, res.data.expires_in)
							this.saveUser(res.data.user)
							useMessagingStore().setActiveParticipant(res.data.user)
							this.auth_refresh = false;
						}else{
							this.auth_refresh = false;
						}
					}
					catch (e) {
						this.auth_refresh = false;
					}
				}
			}else{
				this.logout();
			}
		},
    async fetchUserParents(){
      const params = {
        user_id: _gAuth.activeUser().id,
        application_code: _gAuth.appCode()
      }
      let urlSearchParams = _gHlp.generateQueryParams(params);
      try {
        const res = await axios.get(services.access_control + 'user-inline-up-list?'+ urlSearchParams, { headers: getHeader() })
        this.auth_user.parent_ids = res.data.data.map(item => item.id)
      }catch(e) {
        // _gNotif.errorFunction(e)
      }
  },
		async fetchConstantData(){
			useAccessControlStore().getUsers(_gAuth.activeCorporateId());
			useAccessControlStore().getUserBankerList();
			useAccessControlStore().getUserLoanOfficer();
			useAccessControlStore().getUserSeList();
			useAccessControlStore().getUserSseList();
			useAccessControlStore().getUserSsaList();
			useAccessControlStore().getUserHubManagerList();
      useAccessControlStore().getCorporates();
      await this.fetchUserParents()
			useLookupStore().initConstant();
			useMessagingStore().getListParticipant();
		}
  }
})